/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const CheckMark = ({
    title,
    titleId = "tm-circle-check",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden={!title}
        role={title ? "img" : ""}
        aria-labelledby={titleId}
        height="1em"
        width="1em"
        fill="none"
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="#F69576"
            d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z" />
        <path stroke="#F0FEF1"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m16.63 8.51-4.857 6.477a1.257 1.257 0 0 1-1.89.135L7.37 12.61" />
    </svg>
);

export default CheckMark;
